import { Axiom } from '@axiomhq/js';

async function getSessionData(userId) {
  const supabase = useSupabaseClient();
  let { data, error } = await supabase.from('user_sessions').select('*').eq('user_id', userId);

  if (error) {
    console.error(error);
    return;
  }

  return data;
}
export default defineNuxtRouteMiddleware(async (to, _from) => {
  const config = useRuntimeConfig();
  // const axiom = new Axiom({
  //   token: config.public.axiomToken,
  //   orgId: config.public.axiomOrgId,
  // });
  const user = useSupabaseUser();
  const path = '/sign-up';

  // const sessionData = await getSessionData(user.value?.id);

  // if (sessionData?.length > 1) {
  //   console.log(config);
  //   console.error('Found more than 1 session :: redirecting to restricted page');
  //   axiom.ingest('errors', [{ type: 'account-sharing', user: user.value }]);
  //   return navigateTo('/restricted/single-user');
  // }

  console.log('`requires-membership` Middleware');
  console.log('sessionData');
  console.log('userId', user.value?.id);
  // console.log(sessionData);
  const { profile, fetchProfile } = useProfileStore();
  if (!profile) await fetchProfile(user.value);
  console.log(profile.subscriptions);
  if (!user.value || !profile || !profile.subscriptions.find((sub) => sub.status == 'active')) {
    console.log('requires-membership` Middleware found user... redirecting to ' + path);
    return navigateTo(path);
  }
});
